import { Search, X } from 'lucide-react';
import Input from './Input';

// Search box with a clear button, shared by every admin list page. Controlled
// — the page owns the value and debounces it before querying the API.
export default function SearchInput({ value, onChange, placeholder = 'Search…', className }) {
  return (
    <div className={className ?? 'w-full sm:w-72'}>
      <Input
        icon={Search}
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={placeholder}
        // The native WebKit clear "x" would double up with ours.
        className="[&::-webkit-search-cancel-button]:appearance-none"
        rightElement={
          value ? (
            <button
              type="button"
              onClick={() => onChange('')}
              aria-label="Clear search"
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
            >
              <X size={14} />
            </button>
          ) : null
        }
      />
    </div>
  );
}
